import { Children } from 'react'
import { Box } from '@mui/material'

/**
 * Overview card + stat cards in a responsive grid (stacks until lg to avoid squeeze/overlap).
 */
export function DashboardSummaryRow({ overview, children, sx }) {
  const stats = Children.toArray(children).filter(Boolean)
  const statCols = stats.length > 0 ? ` repeat(${stats.length}, minmax(0, 1fr))` : ''

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: stats.length >= 2 ? 'repeat(2, minmax(0, 1fr))' : '1fr',
          lg: `minmax(0, 2fr)${statCols}`,
        },
        gap: 2,
        mb: 3,
        alignItems: 'stretch',
        '& > *': { minWidth: 0 },
        ...sx,
      }}
    >
      <Box sx={{ gridColumn: { xs: '1', sm: '1 / -1', lg: 'auto' }, minWidth: 0 }}>{overview}</Box>
      {stats}
    </Box>
  )
}
